import BaseMenu from '../../components/dropdown/BaseMenu/Component'
import { GET } from '@/api/api'
import { useSetAtom } from 'jotai'
import { isLoadingAtom } from '@/store/loading'
import { MenuItemType } from '../../components/dropdown/BaseMenu/Component'
import { showError } from '@/shared/toast'
import { tableName } from '@/types/tableName'

type Props = {
  tableName: tableName
}

export const CsvMenu = ({ tableName }: Props) => {
  const setLoading = useSetAtom(isLoadingAtom)
  const onClick = async (outputMode: string) => {
    console.log('CSVをダウンロード')
    setLoading(true)
    await downloadCsv(tableName, outputMode)
      .catch((err: Error) => {
        showError('CSVのダウンロードに失敗しました。')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const menuItems: MenuItemType[] = [
    {
      key: 'csv_output',
      value: (
        <>
          <div className="icon">
            <img src="/images/file-export-icon.svg" alt="" />
          </div>
          <div className="label">CSV出力</div>
        </>
      ),
      subMenuItems: [
        {
          key: 'output_mode_1',
          value: <div>現在適用中のみ</div>,
          onClick: () => onClick('1'),
        },
        {
          key: 'output_mode_2',
          value: <div>現在適用中と適用待ちのみ</div>,
          onClick: () => onClick('2'),
        },
        {
          key: 'output_mode_3',
          value: <div>すべて（過去の情報含む）</div>,
          onClick: () => onClick('3'),
        },
      ],
    },
  ]

  return (
    <BaseMenu
      triggerButtonText={
        <img
          src="/images/ellipsis-vertical-solid.svg"
          alt="メニュー"
          style={{ width: '16px', height: '16px' }}
        />
      }
      menuItems={menuItems}
      menuWidth={155}
      subMenuWidth={235}
    />
  )
}

/**
 * CSVをダウンロードする
 * @param dataType "health_insurers":保険者, "destinations":送達先
 * @param outputMode 1:現在適用中のみ, 2:現在適用中と適用待ちのみ, 3:すべて（過去の情報含む）
 */
async function downloadCsv(dataType: tableName, outputMode: string) {
  await GET<Blob>(
    `/api/csv/${dataType}?output_mode=${outputMode}`,
    undefined,
    undefined,
    'blob',
  )
}
